export { default as VehicleDamageModel } from './vehicle-damage-model';
